import { RootState } from "app.store";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeItemCartApi, removeItemShoppingCartApi, updateItemCartApi, updateItemShoppingCartApi } from "states/cart/cart.api";
import { ShoppingCartItem, UpdateItemModel,  WebsiteRemoveShoppingCartItemModel, WebsiteUpdateShoppingCartItemModel } from "states/cart/cart.models";
import { globalValueGetCart, globalValueSetLoading, globalValueSetToast, globalValueShowConfirmModal } from "states/global-value/global-value.action";
import { ConfirmModel, ToastModel, ToastType } from "states/global-value/global-value.models";
import { formatMoney } from "../../shared/plugins/string-helper";

interface ItemProductProps {
  orderItem: ShoppingCartItem;
}
export const ItemProductComponent = (props: ItemProductProps) => {
  const { orderItem } = props;
  const isGetCart = useSelector((state: RootState) => state.globalValue.isGetCart);
  const isAuthenticated = useSelector((state: RootState) => state.account.isAuthentication);
  const dispatch = useDispatch();
  const _handleRemoveOrderItem = async (id: string | number) => {
    dispatch(globalValueSetLoading(true));
    try {
      if(isAuthenticated){
        await removeItemCartApi(id);
      }else{
        await removeItemShoppingCartApi({skuId: id} as WebsiteRemoveShoppingCartItemModel)
      }
      dispatch(globalValueGetCart(!isGetCart));
      dispatch(globalValueSetLoading(false));
    } catch(error) {
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleIncreaseOrderItem = async (id: string| number, quantity: number) => {
    dispatch(globalValueSetLoading(true));
    try {
      quantity += 1;
      if(isAuthenticated){
        await updateItemCartApi({
          skuId: id,
          quantity: quantity
        } as UpdateItemModel);
      }else{
        await updateItemShoppingCartApi({
          item:{
            skuId: id,
            quantity: quantity
          }
        } as WebsiteUpdateShoppingCartItemModel);
      }
      dispatch(globalValueGetCart(!isGetCart));
      dispatch(globalValueSetLoading(false));
    } catch(error) {
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleUpdateOrderItem = async (id: string| number, quantity: number) => {
    if (quantity <= 1) {
      dispatch(
        globalValueSetToast({
          message: "Vui lòng nhập số lượng lớn hơn 0",
          type: ToastType.error,
        } as ToastModel)
      );
      return false;
    }
    try {
      if(isAuthenticated){
        await updateItemCartApi({
          skuId: id,
          quantity: quantity
        } as UpdateItemModel);
      }else{
        await updateItemShoppingCartApi({
          item:{
            skuId: id,
            quantity: quantity
          }
        } as WebsiteUpdateShoppingCartItemModel);
      }
      dispatch(globalValueGetCart(!isGetCart));
      dispatch(globalValueSetLoading(false));
    } catch(error) {
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleDecreaseOrderItem = async (id: string| number, quantity: number) => {
    if (quantity <= 1) {
      dispatch(
        globalValueSetToast({
          message: "Vui lòng nhập số lượng lớn hơn 0",
          type: ToastType.error,
        } as ToastModel)
      );
      return false;
    }
    dispatch(globalValueSetLoading(true));
    try {
      quantity -= 1;
      if(isAuthenticated){
        await updateItemCartApi({
          skuId: id,
          quantity: quantity
        } as UpdateItemModel);
      }else{
        await updateItemShoppingCartApi({
          item:{
            skuId: id,
            quantity: quantity
          }
        } as WebsiteUpdateShoppingCartItemModel);
      }
      dispatch(globalValueGetCart(!isGetCart));
      dispatch(globalValueSetLoading(false));
    } catch(error) {
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  
  return ( orderItem ?
    <div className="item-container flex-container flex-center">
      <div className="ava">
        <div className="img-container">
          <img src={orderItem.skuImage} alt="" />
        </div>
      </div>
      <div className="text-container ">
        <h5 className="h6 text-primary">
          {orderItem.skuName}
        </h5>
      </div>
      <div className="action-container flex-container flex-center">
        <button
          className="btn-action"
          onClick={(ev) => {
            ev.preventDefault();
            _handleDecreaseOrderItem(orderItem.skuId, orderItem.quantity);
          }}
        >
          <span className="ecs-minus" />
        </button>
        <input
          value={orderItem?.quantity ?? 0}
          onChange={(ev) => {
            _handleUpdateOrderItem(orderItem.skuId, parseInt(ev.target.value));
          }}
          type="text"
          className="quantity"
          name="quantity"
        />
        <button
          onClick={(ev) => {
            ev.preventDefault();
            _handleIncreaseOrderItem(orderItem.skuId, orderItem.quantity);
          }}
          className="btn-action"
        >
          <span className="ecs-plus" />
        </button>
      </div>
      <h6 className="h5 text-bold price-container text-black">
        {formatMoney(orderItem.price)}
      </h6>
      <div className="btn-container">
        <button onClick={(ev) =>{
          ev.preventDefault();
          dispatch(globalValueShowConfirmModal({ 
            isModal: true,
            message:"Bạn có muốn xóa sản phẩm này không?",
            onYes: async (ev: any) => { 
              ev.preventDefault(); 
              _handleRemoveOrderItem(orderItem?.skuId);
              dispatch(globalValueShowConfirmModal({isModal: false}));
            },
            onClose: (ev: any) => { 
              ev.preventDefault(); 
              dispatch(globalValueShowConfirmModal({isModal: false}));
            }
          } as ConfirmModel));
        }}>
          <span className="ecs-cancel" />
        </button>
      </div>
    </div>
  : null);
};
